import { AloftDate } from '@aloft/shared-objects';
import { RevisionType } from '@aloft/toolkit-shared';

import { OrderTag } from '../modules/orderManagement/components/OrderTable/types.ts';

export const processOrderTags = ({
  isCompleted, dueDate, revisionType 
} : {
  dueDate?: AloftDate | null,
  isCompleted: boolean,
  revisionType?: RevisionType
}): OrderTag[] => {
  const tags: OrderTag[] = [];
  const now = AloftDate.today();
  if (dueDate && dueDate.compare(now) < 0 && !isCompleted) {
    tags.push(OrderTag.Overdue);
  }

  if (revisionType === 'rov') {
    tags.push(OrderTag.ROV);
  } else if (revisionType === 'revision') {
    tags.push(OrderTag.Revision);
  }

  return tags;
};
